import React, { createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { withRouter, Redirect } from 'react-router-dom';
import AppBar from '@material-ui/core/AppBar';
import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import MessageIcon from '@material-ui/icons/Message';
import CloseIcon from '@material-ui/icons/Close';
import CircularProgress from '@material-ui/core/CircularProgress';
// import { BrokenImageIcon } from '@material-ui/icons/BrokenImage';
// import { Hidden } from '@material-ui/core/Hidden';
import Fab from '@material-ui/core/Fab';
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import CreateIcon from '@material-ui/icons/Create';
import CameraAltOutlinedIcon from '@material-ui/icons/CameraAltOutlined';

import {
  fetchStoryMoments,
  fetchAccountSettings,
  uploadMoments,
  updateStory
} from 'shared/actions/storyActions';

import { setMetaTag } from 'shared/services/MetaTags';

import {
  showNavBarStory,
  showNavBarPrintStore,
  showNavBarModal
} from 'shared/actions/navActions';

import {
  setPhotoSwipeOpen,
  setPhotoSwipeItems,
  setPhotoSwipeIndex,
  setPhotoSwipeMomentId,
  clearPhotoSwipeItems,
  addPhotoSwipeItems,
} from 'shared/actions/photoSwipeActions';

import {
  clearSelectionItems,
  addSelectionItems
} from 'shared/actions/selectionActions';

import {
  getDefaultSharePage
} from 'shared/services/ShareService'

import {
  trackEvent
} from 'shared/services/Analytics';

import { print } from 'shared/utils/Helpers';

import {
  SCREEN_WIDTH_BREAKPOINT,
  STORY_DOWNLOAD_URL
} from 'shared/utils/Constants';

import StoryService from 'shared/services/StoryService';
import PhotoSwipeWrapper from 'shared/components/PhotoSwipe';
import Modal from 'shared/components/Modal';
import PrintStore from 'shared/components/PrintStore';
import { getScrollContainer } from 'shared/services/Scroll';
import Image from 'shared/components/Image';
import Gallery from 'shared/components/Gallery';
import config from 'shared/config/config';

let storyService = new StoryService();

const windowWidth = window.innerWidth;
const isMobile = windowWidth <= 768;
const fontSize = parseInt(window.getComputedStyle(document.body).fontSize);

const styles = theme => ({
  container: {
  },
  toolbar: {
    position: "fixed",
    bottom: theme.spacing.unit * 1,
    right: theme.spacing.unit * 1,
    left: theme.spacing.unit * 1,
    zIndex: 3
  },
  simpleToolbar: {
    position: 'relative',
    float: 'left',
    zIndex: 2,
    background: '#fff',
    width: '100%',
    padding: '0.5rem 1rem'
  },
  pageHeading: {
    fontFamily: '"SF Pro Display Bold", sans-serif',
    fontSize: '1.5rem',
    fontWeight: 700,
    lineHeight: '28pt',
    letterSpacing: '0.54pt',
    marginBottom: "0px"
  },
  headerSpan: {
    float: 'left'
  },
  fab: {
    position: "relative",
    float: "right",
    color: "primary",
    // margin: theme.spacing.unit, // You might not need this now
    marginRight: "15px",
    marginBottom: "15px",
    background: '#3e387b'
  },
  progress: {
    margin: theme.spacing.unit * 2,
    size: 10,
  },
  coverContainer: {
    position: 'relative',
    //position: 'fixed',
    //top: 0,
    //left: 0,
    //right: 0,
    width: '100%',
    height: '10rem',
    //minHeight: '300vh',
    //zIndex: 1,
    //transition: 'transform 1s ease-out',
    background: '#101820',
    boxShadow: '0 -5px 20px 3px rgba(0, 0, 0, 0.3)'
  },
  coverOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: 2,
    background: '#000',
    opacity: 0,
    transition: 'opacity 0.01s'
  },
  cover: {
    position: 'relative',
    float: 'left',
    width: '100%',
    height: '44vw',
    overflow: 'hidden',
    background: '#494949'
  },
  coverImage: {
    position: 'relative',
    zIndex: 1,
    backgroundPosition: "top center",
    backgroundSize: "105% auto",
    width: '100%',
    height: '101%',
    opacity: 0.9
  },
  coverHeaderWrapper: {
    position: 'relative',
    float: 'left',
    width: '100%',
    zIndex: 2
  },
  coverHeader: {
    position: 'absolute',
    left: '0.5rem',
    bottom: '0.5rem',
    float: 'left',
    width: 'auto',
    zIndex: 9,
    opacity: 1,
    background: config.pwa_story_title_bg_color,
    color: config.pwa_story_title_font_color,
    boxShadow: '0 0 3px rgba(0, 0, 0, 0.2)',
    borderRadius: '3px',
    fontSize: '1rem !important',
    padding: '10px',
    fontWeight: '400 !important',
  },
  gallery: {
    float: isMobile ? 'left' : 'right',
    width: isMobile ? '100vw' : '80vw',
    minHeight: '100%',
    position: 'relative',
    zIndex: 3,
    padding: '1rem 1rem 0.5rem',
    background: config.pwa_galleryimage_bg,
    margin: '0px 0px 100px 0px'
  },
  editIcon: {
    fontSize: '20px',
    marginTop: '-4px',
    marginLeft: '5px',
    cursor: 'pointer'
  },
  helpText: {
    display: 'block',
    fontSize: '1.1rem',
    margin: '1.5rem 0',
    color: '#333'
  },
  editForm: {
    position: 'relative',
    zIndex: 2,
    width: '100%',
    background: '#fff',
    padding: '2rem 1rem',
    margin: '20vh auto 0',
    boxShadow: '3px 3px 20px rgba(0, 0, 0, 0.5)',
    maxWidth: '600px',
    borderRadius: isMobile ? 0 : '3px'
  },
  editFormBackdrop: {
    position: 'fixed',
    zIndex: 1,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5))'
  },
  closeIcon: {
    position: 'absolute',
    top: '5px',
    right: '5px',
    color: '#949494',
    opacity: 0.5,
    cursor: 'pointer',
    '&:hover': {
      opacity: 1
    }
  },
  backIcon: {
    display: isMobile ? 'inline' : 'none',
    position: 'fixed',
    zIndex: 3,
    top: '0.5rem',
    left: '0.5rem',
    color: '#fff',
    width: '2rem',
    height: '2rem',
    fontSize: '2rem',
    opacity: 0.7
  },
  simpleBackIcon: {
    float: 'right',
    margin: '0.4rem 0.8rem 0.4rem 0.2rem',
    color: '#777'
  },
  overlay: {
    position: 'fixed',
    zIndex: 2,
    top: 0,
    left: '-100vw',
    bottom: 0,
    width: '100vw',
    background: 'linear-gradient(to left, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.7))',
    transition: 'left 0.5s'
  },
});

const DEFAULT_CUSTOM_SHARE_DIALOG_CONFIG = { name: "", description: "", url: "" };

class Moments extends React.Component {

  constructor(props) {
    super(props);

    window.close = this.handlePhotoSwipeClose.bind(this);

    //this.cover = createRef();
    this.cover = this.props.dragNode;
    this.coverOverlay = createRef();
    this.coverImage = createRef();
    this.coverHeader = this.props.dragNode3;
    this.fileInput = createRef();
    this.openedOnce = false;
    this.scrollApplied = false;
    this.scrolls = 0;

    // for moments, track each index
    this.fadeInApplied = {};

    // hotfix
    window.currentMomentsScreen = this;

    this.state = {
      loading: true,
      redirect: false,
      currentImage: 0,
      showCustomShareDialog: false,
      customShareDialogConfig: DEFAULT_CUSTOM_SHARE_DIALOG_CONFIG,
      uploadInProgress: false,
      uploadCompleted: false,
      uploadError: false,
      printStoreOpen: false,
      editIsOpen: false
    };
  }

  componentDidMount() {
    this.loadMoments()
      .then(() => {
        this.setMetaTags();

        if (window.location.search.match(/gallery=true/)) {
          this.props.setPhotoSwipeOpen(true);
        }
      });
  }

  componentWillUnmount() {
    //const { scrollNode: { current: scrollNode } } = this.props;
    //if (scrollNode) {
    //  scrollNode.removeEventListener('scroll', this.scrollListener);
    //  this.scrollApplied = false;
    //}
  }

  shouldComponentUpdate(newProps, newState) {
    const { story, scrollerId, tabIndex } = this.props;

    return newProps.tabIndex !== tabIndex || this.state.loading !== newState.loading ||
      this.props.storyMoments[story.id] !== newProps.storyMoments[story.id] ||
      this.props.selectionEnabled !== newProps.selectionEnabled ||
      (this.props.openStoryId !== newProps.openStoryId && (newProps.openStoryId === null || newProps.openStoryId === story.id)) ||
      !this.scrollApplied && document.getElementById(scrollerId);
  }

  componentDidUpdate() {
    // if desktop, create side div with cover and title
    //if (!this.state.loading && !this.scrollLoopActive && isMobile && this.cover && this.cover.current) {
    //  this.scrollLoopActive = true;

    //  this.scrollContainer = getScrollContainer(this.cover.current);
    //  //this.scrollContainer.addEventListener('scroll', this.onScroll);
    //  this.scrollTop = 0;//window.innerHeight; // the top of the story

    //  // begin parallax scrolling of cover
    //  // -- disabled
    //  this.scrollLoop();
    //}

    // setup Add Photos button
    if (this.fileInput.current) {
      this.fileInput.current.style.position = 'absolute';
      this.fileInput.current.style.opacity = 0;
      this.fileInput.current.style.pointerEvents = 'none';
      this.fileInput.current.style.width = 0;
      this.fileInput.current.style.height = 0;
    }
  }

  applyScroll() {
    const scrollNode = document.getElementById(this.props.scrollerId);

    if (!this.scrollApplied && scrollNode) {
      scrollNode.addEventListener('scroll', this.onScroll.bind(this));
      this.scrollApplied = true;
    }
  }

  onScroll() {
    this.scrolls += 1;

    // rate limit, send new scroll pos to galleries every 5 triggers
    if (this.scrolls % 5 === 0) {
      this.dispatchScrollPos();
    }
  }

  dispatchScrollPos() {
    const { scrollNode: { current: scrollNode } } = this.props;
    if (scrollNode) {
      let event = new CustomEvent('scroll-pos', { detail: scrollNode.scrollTop });
      document.body.dispatchEvent(event);
    }
  }

  setMetaTags() {
    const { story } = this.props;
    const moments = this.loadCachedMoments();

    // choose main moment to share, cover if set or first moment
    let moment = moments[0];
    for (let m of moments) {
      if (m.id === story.cover_moment_id) {
        moment = m;
        break;
      }
    }

    if (moment) {
      getDefaultSharePage(story.id)
        .then(page => {
          setMetaTag('og:title', page.story_name);
          setMetaTag('og:url', page.url);
          setMetaTag('og:image:url', moment.share_preview);
          setMetaTag('og:image:type', moment.type);
          setMetaTag('og:image:width', moment.width);
          setMetaTag('og:image:height', moment.height);
          setMetaTag('og:image:alt', page.story_name);
          setMetaTag('og:description', page.provider_name);
        });
    }
  }

  getMoments(resolve, storyId, page = 1, perPage = 50) {
    return this.props.fetchStoryMoments(storyId, page, perPage, {
      include_thumb_urls: true,
      include_large_thumb_urls: true,
      include_small_preview_urls: true,
      include_preview_urls: true,
      include_print_urls: true,
      webcart: true, // webcart param pulls photos across club med family (like /v2/cart/<story_id>/moments request)
    })
      .then(moments => {
        // this is used to display the first page of moments before the rest load
        if (resolve) {
          resolve();
        }

        this.addMomentsToPhotoSwipe(storyId, moments, true);
        this.props.addSelectionItems(moments);

        if (moments.length < perPage) {
          return Promise.resolve();
        } else {
          return this.getMoments(false, storyId, page + 1, perPage);
        }
      });
  }

  loadCachedMoments() {
    // TODO: For some reason, in mobile cart mode, storyMoments is never populated here even though I can see
    // it updating in storyReducer...
    let momentIds = this.props.storyMoments[this.props.story.id];

    if (momentIds && momentIds.length) {
      return Object.values(this.props.moments.byId).filter(m => {
        return momentIds.indexOf(m.id) !== -1;
      });
    } else {
      return [];
    }
  }

  async loadMoments() {
    const storyId = this.props.story.id;

    this.props.clearPhotoSwipeItems(storyId);
    this.props.clearSelectionItems();

    let moments = this.loadCachedMoments();

    if (!moments.length) {
      await new Promise(resolve => {
        this.getMoments(resolve, storyId);
      });
    } else {
      this.addMomentsToPhotoSwipe(storyId, moments, false)
    }

    if (!this.props.accountSettings[storyId]) {
      await this.props.fetchAccountSettings(storyId, moments[0]);
    }

    const accountSettings = this.props.accountSettings[storyId];

    // only show print store if there are moments other than cutouts and gifs
    let showPrintStore = false;
    for (let moment of moments) {
      if (!moment.cutout && moment.type != 'image/gif') {
        showPrintStore = true;
        break;
      }
    }

    this.setState({
      loading: false,
      showPrintStore: showPrintStore,
      disableAddMoment: accountSettings?.disable_add_photo,
      storyDownloadUrl: STORY_DOWNLOAD_URL(storyId)
    });
  }

  addMomentsToPhotoSwipe(storyId, moments, append) {
    // Let MobileCartStory handle this...
    if (config.mobile_cart) {
      return
    }

    let psItems = [];

    for (let i = 0, l = moments.length; i < l; i++) {
      let m = moments[i];

      // no video support for now
      if (m.type && m.type.match(/video/)) {
        continue;
      }

      psItems.push({
        id: m.id,
        position: m.position,
        src: m.print_url || m.preview_url,
        shareUrl: m.print_url || m.preview_url,
        fallbackShareUrl: m.share_url,
        filename: m.id.toString(),
        mimeType: m.type || 'image/jpeg',
        w: m.width,
        h: m.height,
        printStoreAccessible: !m.cutout && m.type != 'image/gif'
      });
    }

    if (append) {
      this.props.addPhotoSwipeItems(storyId, psItems);
    } else {
      this.props.setPhotoSwipeItems(storyId, psItems);
    }
  }

  scrollLoop = event => {
    //if (this.cover.current) {
    if (this.coverOverlay.current) {
      let scrollPos = this.scrollContainer.scrollTop;
      // -- parallax scroll (disabled)
      ////this.cover.current.style.transform = `translate(0, ${scrollPos * 0.3 * -1}px)`;
      //if (scrollPos > 0) {
      //  this.cover.current.style.top = `${parseInt(scrollPos * 0.3 * -1)}px`;
      //}
      //this.props.dragNode3.current.style.top = `${parseInt(scrollPos * 0.3 * -1)}px)`;

      // darken cover image
      let maxScroll = 800;
      this.coverOverlay.current.style.opacity = scrollPos / maxScroll;

      requestAnimationFrame(e => this.scrollLoop(e));
    }
  }

  addMomentsToStory = event => {
    this.setState({
      uploadInProgress: true,
      uploadCompleted: false,
      uploadError: false
    });

    let files = event.target.files;
    let setCover = !this.props.story.cover_moment_id;

    this.props.uploadMoments(this.props.openStoryId, files, setCover)
      .then(moments => {
        this.setState({
          uploadInProgress: false,
          uploadCompleted: true,
          uploadError: false
        });
      });
  }

  handleOpenCustomShareDialog = (config) => {
    print("CustomShareDialog opened, config: ", config);
    this.setState({ customShareDialogConfig: config, showCustomShareDialog: true });
  }

  handleCloseCustomShareDialog = () => {
    print("CustomShareDialog closed");
    this.setState({ customShareDialogConfig: DEFAULT_CUSTOM_SHARE_DIALOG_CONFIG, showCustomShareDialog: false });
  }

  handleClickMoment = (event, obj) => {
    // hotfix, prevent dragging story from Photowipe
    window.disableStoryDrag = true;

    const {
      setPhotoSwipeIndex,
      setPhotoSwipeMomentId,
      setPhotoSwipeOpen,
      story
    } = this.props;

    if (obj) {
      setPhotoSwipeMomentId(obj.id);
    } else {
      // cover moment was tapped
      if (story.cover_moment_id) {
        setPhotoSwipeMomentId(story.cover_moment_id);
      } else {
        setPhotoSwipeIndex(0);
      }
    }

    setPhotoSwipeOpen(story.id);
  }

  handlePhotoSwipeClose = () => {
    const scrollNode = this.props.scrollNode && this.props.scrollNode.current;

    if (scrollNode && window.savedScroll) {
      scrollNode.scrollTop = window.savedScroll;
    }

    const event = new CustomEvent('show-moments');
    document.body.dispatchEvent(event);
  }

  openPrintStore() {
    this.setState({ printStoreOpen: true });
    this.props.showNavBarPrintStore();

    trackEvent('PrintStore.Open', {
      userId: this.props.user.id,
      storyId: this.props.story.id,
      storyName: this.props.story.name
    });
  }

  close() {
    this.props.close();
  }

  closePrintStore() {
    this.setState({ printStoreOpen: false });
    this.props.showNavBarStory();
  }

  openEdit() {
    this.setState({ editIsOpen: true });
    this.props.showNavBarModal();
  }

  closeEdit() {
    this.setState({ editIsOpen: false });
    this.props.showNavBarStory();
  }

  closeEditModal() {
    window.currentModal.close();
    setTimeout(() => {
      this.closeEdit();
    }, 500);
  }

  updateStory = event => {
    event.preventDefault();

    const form = event.currentTarget;
    const name = form.elements[0].value;

    let params = {
      name: name
    }

    this.props.updateStory(this.props.story.id, params)
      .then(() => {
        this.closeEditModal();
      })
      .catch(err => {
        console.error(err);
      });
  }

  computeColumns = (containerWidth) => {
    let columns = 3;
    if (containerWidth < 490) columns = 3;
    // if (containerWidth >= 500) columns = 2;
    // if (containerWidth >= 900) columns = 3;
    // if (containerWidth >= 1500) columns = 4;
    return columns;
  }

  renderCoverMoment = (classes) => {
    if (isMobile) {
      const { story } = this.props;

      if (!story) {
        return (
          <div style={{ width: "100%", height: "200px", objectFit: "cover", alignContent: "center", justifyContent: "center", backgroundColor: "rgba(0, 0, 0, 0.08)" }}>
            {/* <BrokenImageIcon style={{fill: "lightgray", fontSize: "100px"}}/> */}
            {/* <div style={{margin:"auto", paddingTop: "50px"}}>{"No Cover Photo"}</div> */}
            <h1 style={{ color: "black", paddingTop: "75px" }}>{"Loading.."}</h1>
          </div>
        );
      }

      let coverImageStyle = story.cover_moment_url ? {
        backgroundImage: `url(${story.cover_moment_url})`
      } : {
        background: 'rgb(220 220 220)'
      }

      // disable editing story name for now
      const showEdit = false;

      const storyName = (
        <span>
          <b style={{ fontWeight: 500 }}>{story.name}</b> ({story.purchased_count})
        </span>
      );

      return (
        <div>
          {
            this.props.openStoryId !== null &&
            <ArrowBackIcon className={classes.backIcon} onClick={this.props.close} style={{ display: this.props.photoSwipeOpen ? 'none' : 'inline' }} />
          }

          <div ref={this.props.dragNode} className={classes.coverContainer} style={{ height: this.coverHeight + 'px' }}>
            <div ref={this.coverOverlay} className={classes.coverOverlay}></div>
            <div ref={this.coverImage} className={classes.coverImage} style={coverImageStyle}>
            </div>
          </div>
          <div className={classes.coverHeaderWrapper} style={{ paddingTop: this.coverHeight - 55 + 'px' }} onClick={this.handleClickMoment.bind(this)}>
            <h1 ref={this.coverHeader} className={classes.coverHeader}>
              {storyName}
              <CreateIcon className={classes.editIcon} onClick={() => this.openEdit()} style={{ display: showEdit ? 'inline' : 'none' }} />
            </h1>
          </div>
        </div>
      );
    }
  }

  renderSimpleCoverMoment = (classes, moments) => {
    const { story } = this.props;

    // vertically center cover moment in container (tall img should be centered)
    let coverMoment, coverMomentMarginTop = null;
    for (let m of moments) {
      if (m.id === story.cover_moment_id) {
        coverMoment = m;
        break;
      }
    }

    if (coverMoment && coverMoment.height) {
      let relativeHeight = window.innerWidth / coverMoment.width * coverMoment.height;
      let containerHeight = window.innerWidth * 0.44; // 44vw
      let diff = relativeHeight - containerHeight;

      coverMomentMarginTop = `-${diff / 2}px`;
    }

    return (
      <div>
        <div className={classes.cover}>
          <img className={classes.coverImage} src={story.cover_moment_preview} style={{ marginTop: coverMomentMarginTop, height: "auto"}} />
        </div>
        <div className={classes.simpleToolbar}>
          <h1 className={classes.pageHeading}>
            <span className={classes.headerSpan}>{story.name}</span>
            <CloseIcon className={classes.simpleBackIcon} onClick={() => this.props.close()} />
          </h1>
        </div>
      </div>
    )
  }

  renderAddMomentsStatus = (classes) => {
    // can be used later for upload bar or flash errors
    return null;
    if (this.state.uploadInProgress) {
      return (
        <div>
          <div>Adding Moments...</div>
          {/* <CircularProgress
            // className={classes.progress}
            // variant="determinate"
            // value={this.state.imageLoadProgress}
          /> */}
        </div>
      );
    } else {
      if (this.state.uploadError) {
        return (
          <div>
            <div>An error occurred. Moments were not added.</div>
            {/* <CircularProgress
              // className={classes.progress}
              // variant="determinate"
              // value={this.state.imageLoadProgress}
            /> */}
          </div>
        );
      }
      if (this.state.uploadCompleted) {
        return (
          <div>
            <div>Moments added successfully.</div>
            {/* <CircularProgress
              // className={classes.progress}
              // variant="determinate"
              // value={this.state.imageLoadProgress}
            /> */}
          </div>
        );
      }
    }

  }

  renderImage(attrs) {
    let fadeIn = false, delay = 0;
    if (!this.fadeInApplied[attrs.index]) {
      this.fadeInApplied[attrs.index] = true;
      fadeIn = true;

      // only delay the first 10 images. the rest won't fade in until scrolled too,
      // and the delay isn't needed and wouldn't work as intended.
      if (attrs.index < 10) {
        delay = attrs.index * 50;
      }
    }

    return (<Image attrs={attrs} fadeIn={fadeIn} delay={delay} onClick={this.handleClickMoment.bind(this)} />);
  }

  renderGallery = (classes, moments) => {
    const { user, story } = this.props;

    let galleryStyle = {}
    let galleryMod = 0.8  // reducing size of gallery for side nav
    if (user.theme.hide_nav) {
      galleryStyle = {
        float: 'left',
        width: '100vw',
      }
      galleryMod = 1
    }

    if (!this.state.loading) {
      if (moments.length === 0) {
        let height = isMobile || user.theme.simple_stories ? `calc(105vh - ${parseInt(this.coverHeight)}px)` : '105vh';
        let action = isMobile ? 'Tap' : 'Click';

        let showAddMoments = true;

        if (showAddMoments) {
          return (
            <div ref={this.props.dragNode2} className={classes.gallery} style={{ height: height }}>
              <input type="file" accept="image/*" id="file" multiple ref={this.fileInput} onChange={this.addMomentsToStory} />
              <span className={classes.helpText} style={{ cursor: 'pointer' }} onClick={() => this.fileInput.current.click()}>{action} <CameraAltOutlinedIcon /> to add photos.</span>
            </div>
          );
        } else {
          return (
            <div ref={this.props.dragNode2} className={classes.gallery} style={{ height: height }}>
            </div>
          );
        }

      } else {
        let settings = this.props.accountSettings[story.id];

        let maxResolution = 3;
        let columns = 3;
        let containerWidth = (windowWidth * galleryMod) - (fontSize * 2);
        if (isMobile) {
          maxResolution = 1;
          columns = 2;
          containerWidth = windowWidth - (fontSize * 2);
        } else if (windowWidth <= 1280) {
          maxResolution = 2;
        }

        let gallery = (
          <Gallery
            containerWidth={containerWidth}
            index={0}
            resolution={0}
            maxResolution={maxResolution}
            progressive={true}
            direction={"column"}
            columns={columns}
            onClick={this.handleClickMoment}
            forceVisible={true}
            scrollNode={this.props.scrollNode}
            moments={moments}
            storyId={story.id}
            disableScrollListener={true}
            galleryImageStyle={{
              margin: 0,
              borderRadius: '10px',
              overflow: 'hidden'
            }}
          />
        );

        let psWrapper = (
          <PhotoSwipeWrapper
            onClose={this.handlePhotoSwipeClose}
            printStoreUrl={settings.print_store_url}
            showPrintStore={this.state.showPrintStore}
            passMomentToPrintStore={settings.append_store_moment}
            story={this.props.story}
            showActions={true}
            moments={moments}
          />
        );

        if (isMobile) {
          galleryStyle.minHeight = `calc(105vh - ${parseInt(this.coverHeight)}px)`
          return (
            <div>
              {psWrapper}
              <div ref={this.props.dragNode2} className={classes.gallery} style={galleryStyle}>
                {gallery}
              </div>
            </div>
          );
        } else {
          return (
            <div>
              {psWrapper}
              <div className={classes.gallery} style={galleryStyle}>
                {gallery}
              </div>
            </div>
          );
        }
      }
    } else {
      galleryStyle.height = `calc(105vh - ${parseInt(this.coverHeight)}px)`
      return (<div className={classes.gallery} style={galleryStyle}><span className={classes.helpText}>Loading moments...</span></div>);
    }
  }

  renderHeader = (classes) => {
    // TO DO: fix toolbar "bug"
    // let style = { backgroundColor: "rgba(255, 255, 255, 0.8)", boxShadow: 'none' };
    return (
      <AppBar position="fixed" className={classes.appBar} style={{ backgroundColor: "transparent", boxShadow: 'none' }}>
        <Toolbar style={{ paddingLeft: "0px", paddingRight: "0px" }}>
          <Grid
            justify="space-between"
            container
            style={{ paddingLeft: "5px", paddingRight: "5px" }}
          // spacing={24}
          >
            <Grid item>
              <IconButton
                color="default"
                aria-label="Go back"
                onClick={() => {
                  this.props.history.goBack();
                }}
                className={classes.menuButton}
              >
                <ArrowBackIcon />
              </IconButton>
            </Grid>
            <Grid item>
              <IconButton
                color="default"
                aria-label="Open drawer"
                style={{}}
              >
                <MessageIcon />
              </IconButton>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    );
  }

  //renderToolbar(classes) {
  //  var addMomentIcon = "",
  //    downloadIcon = "",
  //    printStoreIcon = "";

  //  if (!this.state.disableAddMoment) {
  //    addMomentIcon = (
  //      <span>
  //        <input type="file" accept="image/*" id="file" multiple ref="fileUploader" style={{display: "none"}} onChange={this.handleAddMomentsToStory}/>
  //        <Fab color="primary" aria-label="Add a photo" className={classes.fab} onClick={(event) => {this.refs.fileUploader.click();}} style={{height: '75px', width: '75px'}} >
  //          <AddAPhotoIcon style={{fontSize: '2.2rem'}} />
  //        </Fab>
  //      </span>
  //    );
  //  }

  //  if (this.props.moments.length) {
  //    downloadIcon = (
  //      <a href={this.state.storyDownloadUrl}>
  //        <Fab color="primary" aria-label="Download story" className={classes.fab} style={{marginTop: '18px'}}>
  //          <CloudDownloadIcon />
  //        </Fab>
  //      </a>
  //    );
  //  }

  //  if (this.state.showPrintStore) {
  //    printStoreIcon = (
  //      <Fab color="primary" aria-label="Print store" className={classes.fab} style={{marginTop: '18px'}} onClick={this.openPrintStore.bind(this)}>
  //        <ShoppingCartIcon />
  //      </Fab>
  //    );
  //  }

  //  return (
  //    <div className={classes.toolbar}>
  //      { addMomentIcon }
  //      { downloadIcon }
  //      { printStoreIcon }
  //    </div>
  //  );
  //}

  renderPrintStore() {
    const { story } = this.props;
    const accountSettings = this.props.accountSettings[story.id];
    if (accountSettings) {
      return (
        <Modal
          disableScrollbar={true}
          isOpen={this.state.printStoreOpen}
          close={this.closePrintStore.bind(this)}>
          <PrintStore url={accountSettings.print_store_url} />
        </Modal>
      );
    }

    return null;
  }

  renderEditDialog(classes) {
    return (
      <Modal disableScrollbar={true}
        isOpen={this.state.editIsOpen}
        close={this.closeEdit.bind(this)}>
        <div className={classes.editFormBackdrop}></div>
        <div className={classes.editForm}>
          <CloseIcon className={classes.closeIcon} onClick={this.closeEditModal.bind(this)} />
          <Form onSubmit={this.updateStory}>
            <h1 style={{ fontSize: '1.5rem' }}>Edit Story</h1>
            <h2 className={this.state.error ? 'error' : ''}>{this.state.message}</h2>
            <Form.Group>
              <Form.Label for="name" style={{ textAlign: 'left', fontWeight: 500, width: '100%' }}>Story name</Form.Label>
              <Form.Control className={this.state.nameError ? 'error' : ''}
                type="text"
                name="name"
                placeholder="Story name"
                defaultValue={this.props.story.name}
              />
            </Form.Group>
            <Button variant="primary" className="bs-btn bs-btn-primary full-width" style={{ width: '100%', background: '#000', marginTop: '1rem', fontSize: '1.2rem', padding: '0.5rem 0 0.7rem' }} type="submit">
              <span>{this.state.submitting ? 'Updating...' : 'Update'}</span>
            </Button>
          </Form>
        </div>
      </Modal>
    );
  }

  renderOverlay(classes) {
    const style = {};
    if (this.props.selectionEnabled) {
      style.left = 0;
    }

    return (
      <div id="overlay" className={classes.overlay} style={style}></div>
    );
  }

  render() {
    const { classes, user, theme, story, openStoryId } = this.props;

    if (this.state.loading) {
      return null;
    }

    if (this.state.redirect) {
      return (
        <Redirect to="/" />
      );
    }

    if (!story) {
      return (
        <div><span className={classes.helpText}>Loading story...</span></div>
      );
    }

    // on first open, we'll kick off the image rendering.
    // this flag prevents re-rendering on further opens and closes.
    const opened = story.id === openStoryId;
    if (!this.openedOnce && opened) {
      this.openedOnce = true;
    }

    const moments = this.loadCachedMoments();

    let gallery = null;
    let coverMoment = null;
    let containerStyle = {
      float: 'left',
      width: '100%',
      minHeight: '100%',
      background: config.pwa_galleryimage_bg
    };

    if (opened) {
      gallery = this.renderGallery(classes, moments);

      if (user.theme.simple_stories) {
        coverMoment = this.renderSimpleCoverMoment(classes, moments);
      } else {
        coverMoment = this.renderCoverMoment(classes);
      }
    }

    this.renders += 1;

    setTimeout(this.applyScroll.bind(this), 500);

    return (
      <div className={classes.container} style={containerStyle}>
        {coverMoment}
        {this.renderAddMomentsStatus(classes)}
        {gallery}
        {this.renderPrintStore()}
        {this.renderEditDialog(classes)}
        {this.renderOverlay(classes)}
      </div>
    )
  }

}

Moments.propTypes = {
  classes: PropTypes.object.isRequired,
  // Injected by the documentation to work in an iframe.
  // You won't need it on your project.
  container: PropTypes.object,
  theme: PropTypes.object.isRequired,
  story: PropTypes.object,
  dragNode: PropTypes.object,
  dragNode2: PropTypes.object,
  dragNode3: PropTypes.object
};

// const mapState = (state, ownProps) => {
//   const book = state.books[ownProps.index];
//   return {book}
// }

// TO DO: check if you can "map" selected items from parent objects instead of using new objects
const mapStateToProps = (state, ownProps) => ({
  user: state.userReducer.user,
  storyMoments: state.storyReducer.storyMoments,
  accountSettings: state.storyReducer.accountSettings,
  moments: state.storyReducer.moments,
  screenWidth: state.screenReducer.dimensions.width,
  photoSwipeOpen: state.photoSwipeReducer.open,
  modals: state.modalReducer.modals,
  selectionEnabled: state.selectionReducer.selection.enabled,
  openStoryId: state.storyReducer.openStoryId,
  showPremiumGallery: state.cartReducer.showPremiumGallery,
  isMobileCart: state.cartReducer.isMobileCart
});

const MomentsComponent = withStyles(styles, { withTheme: true })(Moments);
export default connect(
  mapStateToProps,
  { fetchStoryMoments, fetchAccountSettings, uploadMoments, updateStory, showNavBarPrintStore, showNavBarStory, showNavBarModal, setPhotoSwipeOpen, setPhotoSwipeItems, setPhotoSwipeIndex, setPhotoSwipeMomentId, addPhotoSwipeItems, clearPhotoSwipeItems, clearSelectionItems, addSelectionItems }
)(withRouter(MomentsComponent));
